import { RouteObject } from 'react-router-dom';
import { RedirectPage } from '@sib/auth';
import { loadable } from '@sib/ui';
import { paths } from '@spendbrain/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.login,
    element: loadable(() => import('./pages/LoginPage')),
  },
  {
    path: paths.redirect,
    element: <RedirectPage fallbackPath={paths.login} />,
  },
];
